/*  PROPS CONTROLLER:

    - show
    - title
    - text
    - showInput
    - inputLabel
    - showButtons
    - confirmFunction
    - confirmButtonText
    - cancelFunction
    - cancelButtonText
    - onClose
*/

// STYLE LINKS
import styles from './css/boxAlert.module.css';

// IMPORT ICONS
import { IoMdCloseCircle } from 'react-icons/io';


export default function BoxAlert({show, showCloseButton, onClose, title, text, input, inputLabel, showButtons, confirmButtonText, confirmFunction, cancelButtonText, cancelFunction }) {

    return (
        <>
            {show ? (
                <div className={styles.alertComponent}>
                    <div className={styles.overlayCart}></div>

                    <div className={styles.alertBox}>
                        {showCloseButton ? (
                            <button className={styles.closeDataRequest} onClick={() => onClose()}>
                                <IoMdCloseCircle size={25} color="#333" />
                            </button>
                        ) : null}

                        <h1 className={styles.titleAlertBox} style={{ marginBottom: 0 }}>
                            {title}
                        </h1>

                        {text && <p className={styles.textAlertBox} style={{paddingBottom: input ? 0 : 60}}>{text}</p>}

                        {input && (
                            <div className={styles.inputRequestArea}>
                                {inputLabel && <p className={styles.labelRequestData}>{inputLabel}</p>}
                                {input}
                            </div>
                        )}

                        {!showButtons ? (
                            <button className={styles.proceedRequestDataBtn} onClick={() => confirmFunction ? confirmFunction() : onClose()}>
                                <p className={styles.textAlertButton}>
                                    {confirmButtonText || 'Ok'}
                                </p>
                            </button>

                        ) : (
                            <div className={styles.buttonsBoxArea}>
                                <button className={styles.buttonBoxConfig} id={styles.leftBoxButton} onClick={() => cancelFunction()}>
                                    <p className={styles.textAlertButton}>
                                        {cancelButtonText || 'Voltar'}
                                    </p>
                                </button>
                                <button className={styles.buttonBoxConfig} id={styles.rightBoxButton} onClick={() => confirmFunction()}>
                                    <p className={styles.textAlertButton}>
                                        {confirmButtonText || 'Prosseguir'}
                                    </p>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            ) : null}
        </>
    );
}
